module.exports = __webpack_public_path__ + "img/verify_2.c3f24a52.png";